import { render, staticRenderFns } from "./DenyPayment.vue?vue&type=template&id=d8a96c60&scoped=true"
import script from "./DenyPayment.vue?vue&type=script&lang=js"
export * from "./DenyPayment.vue?vue&type=script&lang=js"
import style0 from "./DenyPayment.vue?vue&type=style&index=0&id=d8a96c60&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a96c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a96c60')) {
      api.createRecord('d8a96c60', component.options)
    } else {
      api.reload('d8a96c60', component.options)
    }
    module.hot.accept("./DenyPayment.vue?vue&type=template&id=d8a96c60&scoped=true", function () {
      api.rerender('d8a96c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/DenyPayment.vue"
export default component.exports